<template>
  <div slot="no-body" class="border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light mt-4">
    <vs-table :data="requests" class="table-dark-inverted" search pagination>
      <template slot="thead">
        <vs-th>DEMANDE</vs-th>
        <vs-th>TYPE</vs-th>
        <vs-th>CONTRAT</vs-th>
        <vs-th>PRIORITÉ</vs-th>
        <vs-th>STATUT</vs-th>
        <vs-th>EMIS PAR</vs-th>
        <vs-th>ACTIONS</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <span>{{data[indextr].title}}</span>
          </vs-td>
          <vs-td><span>{{ tr.type }}</span></vs-td>
          <vs-td><span>{{ tr.contract }}</span></vs-td>
          <vs-td>
            <vs-chip :color="getPriorityColor(tr.priority)">{{ tr.priority }}</vs-chip>
          </vs-td>
          <vs-td>
            <vs-chip>{{ tr.status }}</vs-chip>
          </vs-td>
          <vs-td>{{tr.social_reason}}</vs-td>
          <vs-td>
                                        <span class="flex cursor-pointer hover:text-primary" @click="goToSingle(tr.id, tr.has_proved)">
                                            <feather-icon
                                              icon="EyeIcon"
                                              svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                              class="mr-2"
                                            /> Détails
                                        </span>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <br>
    <vs-pagination v-if="last_page && page" :total="last_page" v-model="page"></vs-pagination>
  </div>

</template>

<script>
  import {_buildQuery} from "../../../../helpers/helper";

  export default {
    name: "requests",
    data: () => ({
      requests: [],
      last_page: null,
      page: 1
    }),
    watch: {
      page: function (value) {
        this.getRequests(this.page)
      }
    },
    methods: {
      goToSingle(id, el) {
        let t = el ? 1 : 2
        this.$router.push('/requests/' + id + '/detail/'+t)
      },
      getPriorityColor(priority) {
        priority = priority.toLowerCase();
        if (priority === "normale") return "primary";
        if (priority === "basse") return "success";
        if (priority === "haute") return "danger";
        return "primary";
      },
      getRequests(page) {
        let params = {
          page: this.page
        }
        this.$vs.loading()
        this.$http.get('statistics/customer/request/list' + _buildQuery(params)).then((response) => {
          this.requests = response.data.data
          this.last_page = response.data.last_page;
          this.$vs.loading.close()
        }).catch((error) => {
          this.$vs.loading.close()
          if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "login"})
          }
        })
      }
    },
    mounted() {
      this.getRequests(this.page)
    }
  }
</script>

<style scoped>

</style>
